import moment from "moment";
import "moment/locale/pt-br";

export const formatDate = (date: string | Date, format: string): string =>
  moment(date).format(format);

export const isValidDate = (date: string | Date): boolean =>
  moment(date).isValid();

export const isToday = (date: string | Date): boolean =>
  moment().isSame(moment(date), "day");

export const isRecentDate = (date: string | Date, days = 30): boolean =>
  Math.abs(moment(date).diff(moment(), "days")) <= days;
